import { z } from "zod";

export const ReportExecuteSchema = z.object({
  id: z.number(),
  type: z.literal("odbcReport"),
  subtype: z.null(),
  error: z.null(),
  name: z.string(),
  description: z.string(),
  options: z.object({
    showSummary: z.boolean(),
    ordering: z.number(),
    showFilters: z.boolean(),
    partialSummary: z.boolean(),
    staticHeader: z.boolean(),
    hideSettings: z.boolean(),
    enableGrouping: z.boolean(),
    enableSorting: z.boolean(),
    enableAutofilters: z.boolean(),
    enablePagination: z.boolean(),
    showReportName: z.boolean(),
    autoformatNumbers: z.boolean(),
  }),
  outputTypes: z.array(z.literal("displayData")),
  columns: z.array(
    z.object({ index: z.number(), name: z.string(), type: z.string() })
  ),
  result: z.array(z.array(z.any())),
});

export type ReportExecute = z.infer<typeof ReportExecuteSchema>;
